import React, { useState } from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import { InputAdornment, TextField } from '@mui/material';

import { useIntelState } from '../../context/IntelState';

const EnemySwitcher = () => {
  const { intelState, intelDispatch: dispatch } = useIntelState();
  const [kd, setKd] = useState<string>(intelState.enemyKd);

  const selectEnemy = () => {
    dispatch({ type: 'SET_ENEMY', payload: kd });
    dispatch({ type: 'SET_ENEMY_PLAN', payload: undefined });
  };

  const validateKeyPress = (e: any): void => {
    const regex = /[0-9:]/gm;
    if (e.key === 'Enter') {
      selectEnemy();
      e.preventDefault();
    } else if (!regex.exec(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <TextField
      id='enemy-switcher'
      label='Enemy'
      value={kd}
      variant='outlined'
      size='small'
      sx={{ width: '85px' }}
      onChange={(event) => setKd(event.target.value)}
      onKeyPress={validateKeyPress}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <RefreshIcon
              sx={{
                '&:hover': { cursor: 'pointer', color: 'primary.main' },
              }}
              fontSize='small'
              onClick={() => selectEnemy()}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default EnemySwitcher;
